import React__default from 'react';

const FlexItem = ({ grow, shrink }) => {
  return /* @__PURE__ */ React__default.createElement("div", { style: { display: "block", flexGrow: grow, flexShrink: shrink } });
};

export { FlexItem };
//# sourceMappingURL=FlexItem.js.map
